import React, {useState} from 'react';
import Grid from "@material-ui/core/Grid";
import {DataGrid, ruRU} from "@material-ui/data-grid";
import FormHelperText from "@material-ui/core/FormHelperText";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {GridCellExpand} from "../../../GridCellExpand/GridCellExpand.jsx";



const useStyles = makeStyles(theme => ({
    tableError: {
        borderColor: theme.palette.error.main
    },
}))

const renderCellExpand = (params) => {
    return (
        <GridCellExpand
            value={params.value ? params.value.toString() : ''}
            width={params.colDef.computedWidth}
        />
    )
}

const offenceSelectColumns = [
    {field: 'sequenceNumber', headerName: '№', width: 90},
    {field: 'normativeDocument', headerName: 'Документ', minWidth: 180, renderCell: renderCellExpand},
    {field: 'normativeChapter', headerName: 'Глава', minWidth: 180, renderCell: renderCellExpand},
    {field: 'shortText', headerName: 'Пункт', minWidth: 180, flex: 1, renderCell: renderCellExpand},
]

export const ContractorViolationsTable = ({value, setFieldValue, name, disabled, error, touched}) => {
    const classes = useStyles()
    
    return <Grid container direction={"column"}>
        <Grid item style={{height: 300, width: '100%'}}>
            <DataGrid rows={value?.map((el, index) => ({...el, sequenceNumber: index + 1}))}
                      columns={offenceSelectColumns}
                      density={'compact'}
                      localeText={ruRU?.props?.MuiDataGrid?.localeText || ruRU?.components?.MuiDataGrid?.defaultProps?.localeText}
                      classes={{root: touched && Boolean(error) ? classes.tableError : undefined}}
            />
        </Grid>
        <FormHelperText error={touched && Boolean(error)}>{touched && Boolean(error) ? error : null}</FormHelperText>
    </Grid>
}